// extracted by mini-css-extract-plugin
export default {"container":"EventStatusData_container__rmX21","horizontalContainer":"EventStatusData_horizontalContainer__RrwQf","titleText":"EventStatusData_titleText__ZzvRj"};